import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

export const HeapTracking = ({ id, user, trackScrollDepth = false }) => {
  const language = localStorage?.getItem('i18nextLng');
  const impersonating = !!user?.impersonatorId;
  const identityId = user?.foundry_id;

  return (
    id && (
      <Helmet>
        <script id="heap-analytics-script">
          {`
              window.heapReadyCb = window.heapReadyCb || [], window.heap = window.heap || [], heap.load = function(e, t) {
                window.heap.envId = e, window.heap.clientConfig = t = t || {}, window.heap.clientConfig.shouldFetchServerConfig = !1;
                var a = document.createElement("script");
                a.type = "text/javascript", a.async = !0, a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
                var r = document.getElementsByTagName("script")[0];
                r.parentNode.insertBefore(a, r);
                var n = ["init", "startTracking", "stopTracking", "track", "resetIdentity", "identify", "getSessionId", "getUserId", "getIdentity", "addUserProperties", "addEventProperties", "removeEventProperty", "clearEventProperties", "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn", "onReady", "addPageviewProperties", "removePageviewProperty", "clearPageviewProperties", "trackPageview"],
                    i = function(e) {
                      return function() {
                        var t = Array.prototype.slice.call(arguments, 0);
                        window.heapReadyCb.push({
                          name: e,
                          fn: function() {
                            heap[e] && heap[e].apply(heap, t)
                          }
                        })
                      }
                    };
                for (var p = 0; p < n.length; p++) heap[n[p]] = i(n[p])
              };
              heap.load('${id.toString()}');

              const identityId = ${identityId ? `'${identityId}'` : null};

              if(identityId !== null) {
                  heap.identify(identityId.toString());
              }

              heap.addUserProperties({
                Impersonating: ${impersonating},
                Language: '${language}',
              });
            `}
        </script>
        {trackScrollDepth && (
          <script id="heap-track-scroll-depth">
            {`(function() {
                const throttle = (func, limit) => {
                  let wait = false;
                  return () => {
                    if(!wait) {
                      func.call();
                      wait = true;
                    }
                    setTimeout(() => {
                      wait = false;
                    }, limit);
                  }
                };
                var quarters = 0;
                var scrollHeight, quarterHeight, scrollDistance, divisible, scrollPercent;
                document.addEventListener("scroll", throttle(() => {
                  scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
                  quarterHeight = scrollHeight / 4;
                  scrollDistance = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
                  divisible = Math.trunc(scrollDistance / quarterHeight);
                  if (quarters < divisible && divisible !== Infinity) {
                    scrollPercent = divisible * 25;
                    heap.track('Scroll Depth', {
                      percent: scrollPercent,
                    });
                    quarters++;
                  }
                }, 150));
              }());`}
          </script>
        )}
      </Helmet>
    )
  );
};

HeapTracking.displayName = 'HeapTracking';
HeapTracking.propTypes = {
  id: PropTypes.string,
  user: PropTypes.shape({
    foundry_id: PropTypes.string,
    impersonatorId: PropTypes.string,
    ruleSets: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        active: PropTypes.bool,
      })
    ),
  }),
  trackScrollDepth: PropTypes.bool,
};
